import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconXBrandedDark$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconXBrandedDark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a03573d1eed23000ea000bff0551625ae9bdb460', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '73e04ba3cd6a60b160c3289de650554b3e15eda5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '14953fb8caa83507ddfb722b1139481e90aed1d7', d: "M12.317 9.775 18.144 3h-1.38l-5.06 5.883L7.66 3H3l6.112 8.896L3 19h1.381l5.344-6.212L13.993 19h4.661zm-1.892 2.199-.62-.886L4.88 4.04H7l3.977 5.688.62.886 5.168 7.393h-2.121z", fill: "#000" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-x-branded-dark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-x-branded-dark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-x-branded-dark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconXBrandedDark$1);
            }
            break;
    } });
}

const CosmosIconXBrandedDark = CosmosIconXBrandedDark$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconXBrandedDark, defineCustomElement };
